import React, { useEffect, useRef } from "react";
import SelectDropdown from "react-native-select-dropdown";
import { View, Text, StyleSheet, Pressable, useWindowDimensions } from "react-native";
import { ChevronDown, ChevronUp } from "lucide-react-native";
import { Box, CloseIcon, Icon, Typography } from "components/ui";
import { Link, useLocalSearchParams, useNavigation } from "expo-router";
import { MotiView } from "moti";
import { H2 } from "components/ui";
import { SelectBaseProps } from "types/select.types";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { styled } from "@gluestack-style/react";

interface SelectOption {
	value: string;
	label: string;
}

interface SelectProps extends SelectBaseProps {
	options: SelectOption[];
	placeholder?: string;
	format?: (item: any) => string;
	defaultValue?: string;
	label?: string;
	value?: string;
	onChange?: (value: string) => void;
}

const StyledMotiView: any = styled(MotiView, {});

export const Select: React.FC<SelectProps> = ({ options, onChange, placeholder, format, defaultValue, label, value }) => {
	const dropdownRef = useRef<any>();
	const navigation = useNavigation();
	const { height: windowHeight, width: windowWidth } = useWindowDimensions();
	const isMobile = useIsMobile();

	const clear = () => {
		dropdownRef.current!.reset();
		onChange?.("");
	};

	const params = useLocalSearchParams();

	useEffect(() => {
		if (params?.selectdata && params?.selectdata != "undefined") {
			const selectedOption = options.find((item) => item.value === params.selectdata);
			if (selectedOption) {
				onChange?.(selectedOption.value);
			}
			// @ts-ignore
			navigation.setParams({ selectdata: undefined });
		}
	}, [params?.selectdata]);

	if (isMobile) {
		return (
			<Box style={{ position: "relative" }}>
				<Link href="/dropdown">
					{!value && <H2>{placeholder}</H2>}
					{value && <H2>{options.find((opt) => opt.value === value)?.label || value}</H2>}
				</Link>
			</Box>
		);
	}

	return (
		<SelectDropdown
			ref={dropdownRef}
			data={options}
			onSelect={(selectedItem) => onChange?.(selectedItem.value)}
			search={true}
			dropdownOverlayColor="rgba(0,0,0,0)"
			renderButton={(selectedItem, isOpen) => (
				<View style={styles.dropdownButtonStyle}>
					{label && (
						<Typography
							sx={{
								position: "absolute",
								top: -11,
								zIndex: 1,
								lineHeight: "1.5",
								left: 11,
								background: "#FAFAFA",
								paddingLeft: 6,
								fontSize: 13,
								fontWeight: 700,
								paddingRight: 6,
							}}
						>
							{label}:
						</Typography>
					)}

					{!selectedItem && <Text style={{ color: "lightgrey", flex: 1 }}>{placeholder}</Text>}
					{selectedItem && (
						<>
							<Text style={styles.dropdownButtonTxtStyle}>{selectedItem.label}</Text>
							<Pressable onPress={clear}>
								<Icon color="blue" as={CloseIcon} m="$2" size="md" />
							</Pressable>
						</>
					)}

					{isOpen && <ChevronUp color="black" />}
					{!isOpen && <ChevronDown color="black" />}
				</View>
			)}
			renderItem={(item, index, isSelected) => (
				<View key={index} style={[styles.dropdownItemStyle, isSelected && { backgroundColor: "red" }]}>
					<Text style={styles.dropdownItemTxtStyle}>{item.label}</Text>
				</View>
			)}
			dropdownStyle={styles.dropdownMenuStyle}
		/>
	);
};

const styles = StyleSheet.create({
	dropdownButtonStyle: {
		width: "100%",
		height: 50,
		backgroundColor: "white",
		borderWidth: 1,
		borderRadius: 12,
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
		paddingHorizontal: 12,
		position: "relative",
	},
	dropdownButtonTxtStyle: {
		flex: 1,
		fontSize: 18,
		fontWeight: "500",
		color: "#151E26",
		textAlign: "center",
	},
	dropdownMenuStyle: {
		backgroundColor: "#E9ECEF",
		borderRadius: 8,
	},
	dropdownItemStyle: {
		width: "100%",
		flexDirection: "row",
		paddingHorizontal: 12,
		justifyContent: "center",
		alignItems: "center",
		paddingVertical: 12,
		borderBottomWidth: 1,
		borderBottomColor: "#B1BDC8",
	},
	dropdownItemTxtStyle: {
		flex: 1,
		fontSize: 18,
		fontWeight: "500",
		color: "#151E26",
		textAlign: "center",
	},
	dropdown1ButtonArrowStyle: {
		fontSize: 28,
		color: "#FFFFFF",
	},
});
